import React from 'react';
import { Button, StyleSheet, Text, View } from 'react-native';
import { NavigationProp } from '@react-navigation/native';
import { AuthStackParamList } from '../../_modules/core/types/Navigation';

interface DummyScreenProps {
  navigation: NavigationProp<AuthStackParamList>;
}

const NoAccessScreen = ({ navigation }: DummyScreenProps) => {
    const changePage2 = () => {
        navigation.navigate('Homepage');
    };
    return (
        <View style={styles.container}>
            <Text style={{ padding: 20 }}>
                You do not have access to this page.
            </Text>
            <Button title="Torna alla home" onPress={changePage2} />
        </View>
    );

}
const styles = StyleSheet.create({
    container: { flex: 1, backgroundColor: '#fff', paddingTop: 20, paddingBottom: 20, paddingHorizontal: 16, color: '#000000' },
});

export default NoAccessScreen;
